
//系统目录 / 药品剂型 接口相关的函数
import request from "../../untils/request.js"

/**
 *
 *  post
 *
 */

//坐诊列表
export const getSchedulingData = (params) => {
    return request.get("/outpatient/dutytable/page", {params} )
}

//坐诊列表
export const getActiveList = (params) => {
    return request.get("/outpatient/dutytable/activeList", {params} )
}

//科室列表
export const getDeptList = (params) => {
    return request.get("/outpatient/findAttribute", {params} )
}

//医生列表
export const getDoctorList = (params) => {
    return request.get("/outpatient/list", {params} )
}

//排班新增
export const addScheduling = (data) => {
    return request.post("/outpatient/dutytable", data )
}

//排班修改
export const editScheduling = (data) => {
    return request.put("/outpatient/dutytable", data )
}

//排班详情
export const getSchedulingDtail = (params) => {
    return request.get("/outpatient/dutytable/get", {params} )
}

//审核、作废
export const checkScheduling = (params) => {
    return request.get("/outpatient/dutytable/check", {params} )
}

//医生排班时间列表
export const getDoctorDateList = (params) => {
    return request.get("/outpatient/dutytable/doctorDutyList", {params} )
}




export default{
    getSchedulingData,getActiveList,getDoctorDateList
}